import {
  GreyGrey30,
  LayoutChromeLeading,
  Flex
} from '@sequencehq/core-components'
import { DatePresetSelect } from 'modules/Insights/common/DatePresetSelect/DatePresetSelect'

interface ControlsProps {
  preset: string
  onChangePreset: (preset: string) => void
}

export const Controls: React.FC<ControlsProps> = ({
  preset,
  onChangePreset
}) => {
  return (
    <Flex
      placeItems="center"
      px={6}
      py={3.5}
      h="65px"
      borderBottom={`1px solid ${GreyGrey30}`}
      gap={3}
    >
      {/* This bar is the page's only header, so it carries the nav toggle. */}
      <LayoutChromeLeading />
      <DatePresetSelect value={preset} onChangeDatePreset={onChangePreset} />
    </Flex>
  )
}
